import { render, staticRenderFns } from "./business-return-addresses.vue?vue&type=template&id=1149677c&scoped=true&"
import script from "./business-return-addresses.vue?vue&type=script&lang=js&"
export * from "./business-return-addresses.vue?vue&type=script&lang=js&"
import style0 from "./business-return-addresses.vue?vue&type=style&index=0&id=1149677c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1149677c",
  null
  
)

export default component.exports